import React from 'react';
import { Box, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useI18n } from '../../../lib/hook/useI18n';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& a': {
      color: theme.palette.secondary.main,
    },
  },
}));

const PrivacyPolicy: React.FC = (): JSX.Element | null => {
  const classes = useStyles();
  const { tHtml } = useI18n();

  const translation = tHtml('room.privacy_policy');

  if (!translation) {
    return null;
  }

  return (
    <Box mt={1.5} className={classes.root}>
      <Typography color="textSecondary" variant="subtitle2">
        {translation}
      </Typography>
    </Box>
  );
};

export default PrivacyPolicy;
